import Reflux from 'reflux'
import RecordsActions from '../actions/RecordsActions'

export var RecordsCmpStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(RecordsActions.recordsCmp,'onRecordsCmp');
	},
    onRecordsCmp(data,groupAlias,groupSource,immediately)
    {
		this.trigger(data,groupAlias,groupSource,immediately);
    }
});

export var DataGridUserChangeStore = Reflux.createStore(
{    
    init:function()
    {
        this.listenTo(RecordsActions.dataGridUserChanged,'onDataGridUserChanged');
    },
    onDataGridUserChanged(currentRecord,groupAlias,gridId,moduleInstanceId,delay = true)
    {
        this.trigger(currentRecord,groupAlias,gridId,moduleInstanceId,delay);
    }
});

export var RecordFieldChangeStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordFieldChanged,'onRecordFieldChanged');
    },
    onRecordFieldChanged(record,dataField,oldValue,newValue,observer)
    {
        this.trigger(record,dataField,oldValue,newValue,observer);
    }
});

export var RecordDataMethodFieldChangedStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordDataMethodFieldChanged,'onRecordDataMethodFieldChanged');
    },
    onRecordDataMethodFieldChanged(dataField)
    {
        this.trigger(dataField);
    }
});

export var RecordAutoSaveStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordAutoSave,'onRecordAutoSave');
    },
    onRecordAutoSave(groupAlias,results)
    {
        this.trigger(groupAlias,results);
    }
});

export var RecordAutoSaveCmpStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordAutoSaveCmp,'onRecordAutoSaveCmp');
    },
    onRecordAutoSaveCmp(groupAlias,record)
    {
        this.trigger(groupAlias,record);
    }
});

export var RenderUpdateModifiedTagStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RenderUpdateModifiedTag,'onRenderUpdateModifiedTag');
    },
    onRenderUpdateModifiedTag(groupAlias,record)
    {
        this.trigger(groupAlias,record);
    }
});

export var RecordsRestoreCmpStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordsRestoreCmp,'onRecordsRestoreCmp');
    },
    onRecordsRestoreCmp(groupAlias,records,moduleInstanceId)
    {
        this.trigger(groupAlias,records,moduleInstanceId);
    }
});

export var RecordNextStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordNext,'onRecordNext');
    },
    onRecordNext(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordNextPageStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordNextPage,'onRecordNextPage');
    },
    onRecordNextPage(onlyFetch,groupAlias,moduleInstanceId)
    {
        this.trigger(onlyFetch,groupAlias,moduleInstanceId);
    }
});

export var RecordPrevPageStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordPrevPage,'onRecordPrevPage');
    },
    onRecordPrevPage(onlyFetch,groupAlias,moduleInstanceId)
    {
        this.trigger(onlyFetch,groupAlias,moduleInstanceId);
    }
});

export var RecordFirstStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordFirst,'onRecordFirst');
    },
    onRecordFirst(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordLastStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordLast,'onRecordLast');
    },
    onRecordLast(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordPrevStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordPrev,'onRecordPrev');
    },
    onRecordPrev(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordRefreshStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordRefresh,'onRecordRefresh');
    },
    onRecordRefresh(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordFetchAllStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordFetchAll,'onRecordFetchAll');
    },
    onRecordFetchAll(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }
});

export var RecordNewStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.RecordNew,'onRecordNew');
    },
    onRecordNew(groupAlias,moduleInstanceId)
    {
        this.trigger(groupAlias,moduleInstanceId);
    }

});


export var AutoSaveBeforeStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.autoSaveBefore,'onAutoSaveBefore');
    },
    onAutoSaveBefore(groupAlias)
    {
        this.trigger(groupAlias);
    }

});

export var GroupCurrentRecordChangedStore = Reflux.createStore(
{
    init:function()
    {
        this.listenTo(RecordsActions.groupCurrentRecordChanged,'onGroupCurrentRecordChanged');
    },
    onGroupCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId,causeId,groupSource,parms)
    {
        this.trigger(records,currentRecord,groupAlias,moduleInstanceId,causeId,groupSource,parms);
    }
});

export var GroupCurrentRecordChangedNotGridUserOpStore = Reflux.createStore({

    init:function()
    {
        this.listenTo(RecordsActions.groupCurrentRecordChangedNotGridUserOp,'onGroupCurrentRecordChangedNotGridUserOp');
    },
    onGroupCurrentRecordChangedNotGridUserOp(groupAlias)
    {
        this.trigger(groupAlias);
    }

});



// WEBPACK FOOTER //
// ./src/stores/RecordsStore.js